import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TimeZoneDetails } from 'globals/store/programs.data';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'timezone-picker',
    template: `
<mat-select [value]="selectedTimeZoneId" *ngIf="!!timezones?.length">
  <mat-option *ngFor="let timezone of timezones; let i = index"
    [value]="timezone.timeZoneId"
    (click)="select.emit(timezone)">
    {{timezone.abbr}} (GMT {{ timezone.offsetText }}<span *ngIf="timezones[i-1]?.abbr === timezone.abbr || timezones[i+1]?.abbr === timezone.abbr"> - {{ timezone.timeZoneId }}</span>)
  </mat-option>
</mat-select> 
`,
    standalone: true,
    imports: [MatOptionModule, MatSelectModule, CommonModule],
})
export class TimeZonePickerComponent {
  @Input() selectedTimeZoneId: string
  @Input() timezones: TimeZoneDetails[] = []
  @Output() select: EventEmitter<TimeZoneDetails> = new EventEmitter()
}



